import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { CustomThemeProvider } from "./theme";
import { CssBaseline } from "@mui/material";
import { IntercomProvider } from "react-use-intercom";

import Home from "./pages/Home";
import SplashPage from "./pages/SplashPage"; // Splash page for non-logged-in users
import SignUpFlowWrapper from "./components/signup/SignUpFlowWrapper";
import MemoryGame from "./pages/MemoryGame";
import IntermediateVariableGame from "./pages/IntermediateVariableGame";
import EasyVariableGame from "./pages/EasyVariableGame";
import AdvancedVariableGame from "./pages/AdvancedVariableGame";
import EasyVariableGameInfo from "./pages/EasyVariableGameInfo";
import IntermediateVariableGameInfo from "./pages/IntermediateVariableGameInfo";
import AdvancedVariableGameInfo from "./pages/AdvancedVariableGameInfo";
//import RequestLogin from "./components/signin/RequestLogin";
//import VerifyOtp from './components/signin/VerifyOTP';

// Placeholder Components
//const Home = () => <div>Home Page</div>;

const INTERCOM_APP_ID = "aiyjvdf0";

function App() {
  const [token, setToken] = React.useState(localStorage.getItem("atcRefresh"));

  // Re-check token on route changes
  React.useEffect(() => {
    const checkToken = () => {
      setToken(localStorage.getItem("atcRefresh"));
    };

    // Listen for custom token update event
    window.addEventListener("tokenUpdated", checkToken);

    return () => {
      window.removeEventListener("tokenUpdated", checkToken);
    };
  }, []);

  return (
    <IntercomProvider appId={INTERCOM_APP_ID}>
      <CustomThemeProvider>
        <CssBaseline />
        <Router>
          <Routes>
            {/* Route for the home page (logged-in users only) */}
            <Route
              path="/home"
              element={token ? <Home /> : <Navigate to="/" />}
            />

            {/* Route for the sign-up/sign-in flow */}
            <Route path="/signup" element={<SignUpFlowWrapper />} />

            {/* Route for the splash page (non-logged-in users) */}
            <Route
              path="/memory-game"
              element={token ? <MemoryGame /> : <SignUpFlowWrapper />}
            />

            {/* Variable Game Routes - Info Pages */}
            <Route
              path="/variable-game-easy"
              element={token ? <EasyVariableGameInfo /> : <SignUpFlowWrapper />}
            />
            <Route
              path="/variable-game-intermediate"
              element={
                token ? <IntermediateVariableGameInfo /> : <SignUpFlowWrapper />
              }
            />
            <Route
              path="/variable-game-advanced"
              element={
                token ? <AdvancedVariableGameInfo /> : <SignUpFlowWrapper />
              }
            />

            {/* Variable Game Routes - Actual Games */}
            <Route
              path="/variable-game"
              element={token ? <EasyVariableGame /> : <SignUpFlowWrapper />}
            />
            <Route
              path="/intermediate-variable-game"
              element={
                token ? <IntermediateVariableGame /> : <SignUpFlowWrapper />
              }
            />
            <Route
              path="/advanced-variable-game"
              element={token ? <AdvancedVariableGame /> : <SignUpFlowWrapper />}
            />
            <Route
              path="/"
              element={!token ? <SplashPage /> : <Navigate to="/home" />}
            />

            {/* Catch-all route */}
            <Route path="*" element={<Navigate to={token ? "/home" : "/"} />} />
          </Routes>
        </Router>
      </CustomThemeProvider>
    </IntercomProvider>
  );
}

export default App;
